import intervalToDuration from 'date-fns/intervalToDuration';
import format from 'date-fns/format';

export const formatDate = (date: Date) => {
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

export const formatDateWithHours = (date: Date) => {
  return format(date, 'Pp');
};

export const getDateInTimezone = (
  year: number,
  month: number,
  day: number,
  hours: number,
  minutes: number,
  timezone: string,
) => {
  const monthString = `${month + 1}`.padStart(2, '0');
  const dayString = `${day}`.padStart(2, '0');
  const hourString = `${hours}`.padStart(2, '0');
  const minutesString = `${minutes}`.padStart(2, '0');

  return new Date(
    `${year}-${monthString}-${dayString}T${hourString}:${minutesString}:00.000${timezone}`,
  );
};

/**
 * The `date-fns` {@link Duration} object doesn't support milliseconds
 */
export type PreciseDuration = Duration & {
  milliseconds?: number;
};

/**
 * Convert a milliseconds offset into a duration object that includes milliseconds
 * @param ms
 */
export function millisecondsToPreciseDuration(ms: number): PreciseDuration {
  const duration = intervalToDuration({
    start: 0,
    end: ms,
  });
  const leftoverMilliseconds = ms % 1000;
  return {
    ...duration,
    milliseconds: leftoverMilliseconds,
  };
}
